import { PageHeader } from 'Common';
import AccountSettingsTabs from 'Components/Dashboard/AccountSettingsTabs';
import DashboardBody from 'Components/Dashboard/DashboardBody';
import DashboardVerificationBannerContainer from 'Components/Dashboard/DashboardVerificationBannerContainer';
import CONFIG from 'Config/settings';
import DynamicNotificationsContainer from 'Notifications/DynamicNotifications/DynamicNotificationsContainer';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { t } from 'Utils/localization/i18next';
import DynamicNotification from '../_notifications/DynamicNotification';
import styles from './DashboardFamilyContainer.module.scss';

const DashboardFamilyContainer = props => {
  return (
    <React.Fragment>
      <DashboardVerificationBannerContainer />
      <DashboardBody>
        <div className={styles['notifications-container']}>
          <DynamicNotificationsContainer id="family-dashboard-notifications" />
          {CONFIG.FEATURE.FAMILY_DASHBOARD.SHOW_CONSENT_NOTIFICATION && (
            <DynamicNotification
              allowEmail={props.allowEmail}
              allowSMS={props.allowSMS}
              allowDirectMail={props.allowDirectMail}
              allowPhone={props.allowPhone}
            />
          )}
        </div>
        <div id="account-settings">
          <PageHeader>
            {t(`dashboard.account-settings.header.title`)}
          </PageHeader>
          <AccountSettingsTabs profileType={props.profileType} />
        </div>
      </DashboardBody>
    </React.Fragment>
  );
};

DashboardFamilyContainer.propTypes = {
  payments: PropTypes.array,
  profileType: PropTypes.string,
  allowEmail: PropTypes.bool,
  allowSMS: PropTypes.bool,
  allowDirectMail: PropTypes.bool,
  allowPhone: PropTypes.bool,
  isPaymentsEnabled: PropTypes.bool,
  history: PropTypes.object,
  match: PropTypes.object
};
const mapStateToProps = state => {
  const payments = state.payment.payments || [];
  return {
    allowEmail: state.profile.allowEmail,
    allowSMS: state.profile.allowSMS,
    allowDirectMail: state.profile.allowDirectMail,
    allowPhone: state.profile.allowPhone,
    profileType: state.profile.profileType,
    payments,
    isPaymentsEnabled:
      CONFIG.FEATURE.FAMILY_DASHBOARD.ENABLE_PAYMENTS_TAB && payments.length > 0
  };
};

const DashboardFamilyContainerWithConnect = connect(
  mapStateToProps,
  null
)(DashboardFamilyContainer);

export default withRouter(DashboardFamilyContainerWithConnect);
